<template>
  <sales-table
    :title="$t('key_out_of_stock_products')"
    :rows="productStocks['items']"
    :pagination="pagination"
    :headers="headers"
    @changed-page="paginationPageChange"
    @row-change="paginationRowChange"
  >
    <template #row="product">
      <td class="font-weight-bold"> 
        <a class="cursor-pointer text-xs font-weight-bold mb-0 picko-link d-block" :title="$t('key_view_product')"
          @click="goToDetalle(product['product_id'])">
          {{product.number}}
        </a>
      </td>
      <td class="font-weight-bold">
        <span class="my-2 text-xs">{{ product.name }}</span>
      </td>
      <td class="font-weight-bold text-end">
        <span class="my-2 text-xs">{{ Math.abs(product.booked - product.requested) }}</span>
      </td>
    </template>
  </sales-table>
</template>
<script>
import SalesTable from "./SalesTable.vue";

export default {
  name: "PendingProductStock",
  components: {
    SalesTable,
    // Globe,
  },
  props: {
    label: {
      type: String,
      default: "Ean",
    },
  },
  data() {
    return {
      pagination: {
        total: 0,
        rows: 5,
        currentPage: 1,
        pages: {
          total: 5,
          current: 1
        },
        entries: [5, 10, 15, 20, 50]
      }
    };
  },
  computed: {
    productStocks() {
      return this.$store.state.dashboard.productStocks.data;
    },
    headers() {
      return [
        { title: this.$t('key_theader_Product_out_of_stock_ean'), sort:{sorteable:false,order:""}, column: "number", class: "text-start"},
        { title: this.$t('key_theader_Product_out_of_stock_sku'), sort:{sorteable:false,order:""}, column: "name", class: "text-start"},
        { title: this.$t('key_theader_Product_out_of_stock_items'), sort:{sorteable:false,order:""}, column: "booked", class: "text-end"},
      ]
    }
  },
  watch: {
    productStocks() {
      if(this.productStocks) {
        this.pagination.total = this.productStocks["total"];
      }
    },
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    goToDetalle(productId){
      if (productId) {
        this.$router.push({ path: "/MasterData/Products/EditProduct/" + productId});
      }
    },
    getProducts(){
      this.$store.commit("dashboard/getProductStock" , {
        filters: {
          sort: {
            sort: "number",
            order: "ascending"
          }
        },
        pagination: this.pagination
      });
    },
    paginationPageChange(page) {
      this.pagination.currentPage = page;
      this.getProducts();
    },
    paginationRowChange(rows) {
      this.pagination.rows = rows;
      this.getProducts(); 
    },
  }
};
</script>
<style scoped>
.overflow-column {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
